"use client";

import { cn } from "@repo/ui/lib/utils";
import type React from "react";
import { useEffect, useState } from "react";

// HeaderBar's bar from sm up: transparent on the canvas at the top of the
// page, solid once the page scrolls under it (the header is sticky there).
export function HeaderSurface({ children }: { children: React.ReactNode }) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const update = () => setScrolled(window.scrollY > 0);
    update();
    window.addEventListener("scroll", update, { passive: true });
    return () => window.removeEventListener("scroll", update);
  }, []);
  return (
    <div
      className={cn(
        "flex h-12 items-center justify-between gap-3 rounded-header px-1 transition-colors sm:h-16 sm:gap-4 sm:px-6",
        scrolled && "sm:bg-background",
      )}
    >
      {children}
    </div>
  );
}
